const WishlistPage = () => {
    return (<>
    <h5>Wishlist</h5>
    </>);
}

export default WishlistPage;